/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Operasional_NameInputs */

const en_mk_sol_operasional_name = /** @type {(inputs: Mk_Sol_Operasional_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`operations and back-office teams`)
};

const id_mk_sol_operasional_name = /** @type {(inputs: Mk_Sol_Operasional_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tim operasional dan back office`)
};

/**
* | output |
* | --- |
* | "operations and back-office teams" |
*
* @param {Mk_Sol_Operasional_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_operasional_name = /** @type {((inputs?: Mk_Sol_Operasional_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Operasional_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_operasional_name(inputs)
	return en_mk_sol_operasional_name(inputs)
});